module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fEY3df/tc-custom/9781488067433.jpg?1725275754058",
      "alt": "This image is the cover for the book Isolated Threat, The Badlands Cops Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Isolated Threat, The Badlands Cops Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A local police officer and a beautiful tribal cop team up to keep a baby from his gang leader father in this romantic suspense.")]), _c('br'), _c('br'), _vm._v("They’ll stop at nothing to protect a child."), _c('br'), _c('br'), _vm._v("Ever since he escaped his father’s biker gang, sheriff’s deputy Brady Wyatt has never looked back. Then Cecilia Mills asks Brady to help her hide a child from the delinquent crew. But when threats impact the safety of the makeshift family, will they find a way to protect themselves . . . or will the Sons of the Badlands take the child back into its dangerous grip?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicole Helm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicole Helm writes down-to-earth contemporary romance and fast-paced romantic suspense. She lives with her husband and two sons in Missouri. Visit her website: www.nicolehelm.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0